<template>
  <div
    @click.self="openDocumentCloudPopUp"
    :class="showFiles && uploaded?.length === 0 ? `${classCst} uploaded` : classCst"
    class="center"
  >
    <div @click="openDocumentCloudPopUp" class="link-icon-text">
      <img v-if="iconButton" class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg" >
      <img v-if="iconButtonSign" class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg" alt="">
      <img v-if="textIconButton" class="nav-link-icon filter-primary" src="https://uploads-ssl.webflow.com/648b04f9d8e52d9524912b4a/648b04f9d8e52d9524912f1e_icons8-upload-to-the-cloud.svg">
      <span v-if="leadingText" class="document-upload-icon" aria-hidden="true">
        <app-icon name="cloud" :size="20" />
      </span>
      <span v-if="leadingText">{{ typeof leadingText === "string" ? leadingText : "nahrať" }}</span>
      <span v-if="textIconButton">cloud</span>
    </div>
    <div
      :class="{'missing-file-title': showFiles && uploaded?.length !== 0}"
      @click="openDocumentCloudPopUp"
      v-if="textButton"
    >
      <span>
        {{ title }}
      </span>
    </div>
    <div
      class="link-block-7 w-inline-block justify-content-between"
      v-for="(file, index) in uploaded"
      :key="index + 'cldfil'"
      v-if="showFiles && uploaded"
    >
      <div class="d-flex flex-row">
        <div class="small fileName">{{ file.name }}</div>
      </div>
      <a
        v-if="file.name.endsWith('.pdf')"
        :href="file.file"
        target="_blank"
        class="text-cta pointer"
      >
        STIAHNUŤ
      </a>
      <div
        v-else
        @click="download(file)"
        class="text-cta pointer"
      >
        STIAHNUŤ
      </div>
      <button
        v-if="allowUnassign"
        type="button"
        class="picked-file-remove"
        title="Odobrať z požadovaného podkladu"
        aria-label="Odobrať z požadovaného podkladu"
        @click.stop="unassignFile(file)"
      >
        ×
      </button>
    </div>
  </div>
</template>

<script>
import {getFile} from "@/services/brokerService";
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "DocumentCloudHandler",
  components: {AppIcon},
  props: {
    type: [Number, null],
    iconButton: Boolean,
    forceFileReplace: Boolean,
    uploaded: Array,
    showFiles: {
      type: Boolean,
      default: true,
    },
    textIconButton: Boolean,
    iconButtonSign: Boolean,
    textButton: Boolean,
    title: [String, null],
    rules: Array,
    cloudMeta: Object,
    classCst: [String, null],
    metaData: [Number, null],
    accept: [String, null],
    leadingText: {
      type: [Boolean, String],
      default: false,
    },
    applicationId: [Number, String, null],
    applicationDocumentType: [String, null],
    allowUnassign: Boolean,
  },
  methods: {
    async unassignFile(file) {
      try {
        await this.$store.dispatch("mortgageDetailCloud/unassignFileType", file);
        this.$store.commit("appState/setSuccessMessage", {
          text: "Podklad bol odobratý z výberu. Súbor zostal uložený v cloude.",
          type: "success",
        });
      } catch (error) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Podklad sa nepodarilo odobrať z výberu.",
          type: "error",
        });
      }
    },
    async download(fileObject) {
      let file = (await getFile(fileObject.file)).data;
      console.log(file)
      const url = URL.createObjectURL(new Blob([file], {
        type: this.getCloudFileTypeByExtension(fileObject.name)
      }))
      const a = document.createElement('a')
      a.href = url
      a.download = fileObject.name;
      a.target = "_blank";
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    // upravene cez GPT kvloii dalsim typom
    getCloudFileTypeByExtension(fileName) {
      const fileExtension = fileName.match(/\.[0-9a-z]+$/i)?.[0]?.toLowerCase();

      switch (fileExtension) {
        case ".pdf":
          return "application/pdf";
        case ".xlsx":
          return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case ".png":
          return "image/png";
        case ".jpg":
        case ".jpeg":
          return "image/jpeg";
        case ".doc":
          return "application/msword";
        case ".docx":
          return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case ".zip":
          return "application/zip";
        case ".asice":
          return "application/vnd.etsi.asic-e+zip"; // oficiálny MIME typ pre .asice
        default:
          return "application/octet-stream"; // bezpečný fallback
      }
    },
    // pridané cez GPT kvoli dalsim typom files
    isFilePdf(fileName) {
      if (!fileName) return false; // žiadne meno, určite nie PDF

      const match = fileName.match(/\.[0-9a-z]+$/i);
      if (!match) return false; // ak nemá príponu, sťahuj

      const fileExtension = match[0].toLowerCase();

      // všetky typy, ktoré sa MAJÚ sťahovať (nie otvárať)
      const nonPdfTypes = [
        ".doc", ".docx", ".zip", ".xlsx", ".png", ".jpg", ".jpeg", ".asice"
      ];

      return fileExtension === ".pdf";
    },
    openDocumentCloudPopUp () {
      if (this.type < 0 && this.uploaded.length > 0) {
        this.$store.commit("appState/setSuccessMessage", {
          text: "Nie je možné priradiť viac ako jeden súbor tomuto typu súboru",
          type: "error"
        });
        return;
      }
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        extra: {
          force: this.forceFileReplace,
          accept: this.accept,
          applicationId: this.applicationId,
          applicationDocumentType: this.applicationDocumentType,
        },
        type: this.type,
        payload: this.cloudMeta,
        component: "DocumentCloudPopUp",
        rules: this.rules,
      });
    }
  }
}
</script>

<style scoped>
.document-upload-icon {
  display: inline-flex;
  width: 34px;
  height: 34px;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  border-radius: 10px;
  background: color-mix(in srgb, var(--app-primary) 15%, transparent);
  color: var(--app-primary);
}
</style>

<style lang="scss" scoped>

.picked-file-remove {
  width: 24px;
  height: 24px;
  margin-left: 8px;
  padding: 0;
  flex: 0 0 24px;
  border: 1px solid rgba(231, 76, 100, 0.45);
  border-radius: 50%;
  background: rgba(231, 76, 100, 0.12);
  color: #e74c64;
  font-size: 18px;
  line-height: 20px;
  cursor: pointer;
}

</style>
